<div *ngIf="historicoPropostaFiltrada.length > 0" class="card card-form">
 <div class="card-header card-form-header mt-1">
  <div class="card mb-5">
   <h3 class="text-center form-section">
    <b>Histórico da Proposta</b>
   </h3>
  </div>
 </div>
 <div class="timeline">
  <div class="timeline-item" *ngFor="let lead of historicoPropostaFiltrada; let i = index"
   [ngStyle]="{'background': getTimelineBackground(i)}">
   <div class="timeline-header">
    <div class="timeline-title">
     <i class="ft-user"></i> {{ lead.userName || 'Usuário desconhecido' }}
    </div>
    <div class="timeline-date">
     <i class="ft-calendar"></i>
     {{ lead.createDate | date: 'dd/MM/yyyy \'às\' HH:mm' }}
    </div>
   </div>

   <div class="timeline-content">
    <ul>
     <li class="timeline-item-li">
      <i class="ft-check-circle"></i>
      {{ lead.summary || 'Ação não informada.' }}
     </li>
     <p class="time-line-descricao mt-2">
      <i class="ft-file-text"></i> {{ lead.description || 'Sem descrição.' }}
     </p>
    </ul>
   </div>
  </div>
 </div>
</div>